import React from "react";
import { Link } from "react-router-dom";

/**
 * Typographic wordmark logo for SparkNext Pathways.
 * No external image — purely a text-based, investor-ready mark.
 */
export const Wordmark = ({ variant = "dark", size = "md" }) => {
  const sizeClasses = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl",
  };

  const primary =
    variant === "light" ? "text-white" : "text-slate-900";
  const accent = "text-amber-500";

  return (
    <Link
      to="/"
      data-testid="wordmark-logo-link"
      className={`inline-flex items-baseline gap-0.5 font-extrabold tracking-tight ${sizeClasses[size]} ${primary} hover:opacity-90 transition-opacity`}
    >
      <span>Spark</span>
      <span className={accent}>Next</span>
      <span className="ml-1.5 hidden sm:inline text-xs font-medium tracking-[0.25em] uppercase text-slate-400">
        Pathways
      </span>
    </Link>
  );
};

export default Wordmark;
